import React from 'react';
import { FormattedMessage } from 'react-intl';
import './styles.scss';
import MaintenanceImg from 'assets/images/empty/Maintenance.png';
import { replaceBrandText } from 'utilities/lang';

const Maintenance = () => {

  return (
    <div className="maintenance-page">
      <div>
        <div className="coming-soon">
          <FormattedMessage id="maintenance.coming_soon" defaultMessage="We'll Be Back Soon!" />
        </div>
        <div>
          <p>
            <FormattedMessage id="maintenance.scheduled_maintenance" defaultMessage="Turn It Blue is undergoing scheduled maintenance." />
          </p>
        </div>
        <div>
          <p>
            <i>
              <FormattedMessage
                id="maintenance.apology"
                defaultMessage="We apologize for the extended delay. This is significant performance upgrade to the platform prior to Election Day, and is taking a bit longer than expected."
              />
            </i>
          </p>
          <p>
            <FormattedMessage
              id="maintenance.check_back_or_contact"
              defaultMessage="Please check back or contact {email} for any urgent needs."
              values={{ email: <a href={replaceBrandText("mailto:success@turnitbluedigital.com")}>{replaceBrandText("success@turnitbluedigital.com")}</a> }}
            />
          </p>
        </div>
      </div>
      <img src={MaintenanceImg} alt="Maintenance" />
    </div>
  );
};

export default Maintenance;
